import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { UpdatePatientSelfPayBitRequest } from 'src/app/models/insurance/inurance';
import { InsurancePhase2Service } from 'src/app/services/insuranceservicephase2/insurance-phase2.service';
import { TranslateService } from '@ngx-translate/core';
import { getPatientDataByURl } from 'src/app/models/verifypatient/verifypatient';

@Component({
  selector: 'app-patientpaymenttype',
  templateUrl: './patientpaymenttype.component.html',
  styleUrls: ['./patientpaymenttype.component.css']
})
export class PatientpaymenttypeComponent implements OnInit {
  isSelfPay: any = false;
  isInsurance: any = false;
  patientpersonalinfo: any;
  landFromCheckin: any;
  PracticeCode: any;
  PatientAccount: any;
  newPatientPersonalInfo: getPatientDataByURl;
  UpdatePatientSelfPayBitRequest: UpdatePatientSelfPayBitRequest = new UpdatePatientSelfPayBitRequest();
  isDrsite: boolean = false;
  isDrsiteIntake: boolean = false;

  constructor(private translateService: TranslateService, private phrUtils: PhrutillsService, private _insuranceservice: InsurancePhase2Service, private _phrutilService: PhrutillsService,
    private spinner: NgxSpinnerService, private router: Router, private location: Location) {

    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this.router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.landFromCheckin = localStorage.getItem("landFrom");
    if (this.landFromCheckin == 'drsite') {
      this.isDrsite = true;
      this.isDrsiteIntake = false;
    } else if (this.landFromCheckin == 'drsiteintake') {
      this.isDrsiteIntake = true;
      this.isDrsite = false;
    }
    console.log("landFromCheckin", this.landFromCheckin);
    if (this.landFromCheckin == 'drsiteintake' || this.landFromCheckin == 'drsite' || this.landFromCheckin == 'new_patient') {
      this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
      this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
      this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
      //console.log("newPatientPersonalInfo in InsuranceType", this.newPatientPersonalInfo);
    }
    else {

      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
      this.PracticeCode = this.patientpersonalinfo.practice_Code;
      this.PatientAccount = this.patientpersonalinfo.patient_Account;
     // console.log("patientpersonalinfo in InsuranceType", this.patientpersonalinfo);
    }
  }

  ngOnInit(): void {
    this.GetPatientInsuranceOrSelfPay()
    if (this.isDrsiteIntake = true) {
      this._phrutilService.patientlanguage$.subscribe(language => {
        //  console.log("dafault " + language);
        if (language === 'es') {
          this._phrutilService.setTitle('Reservar una cita');
        } else if (language === 'hi') {
          this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
        } else if (language === 'ur') {
          this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
        } else if (language === 'gu') {
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
        }
        else {
          this._phrutilService.setTitle('Book an Appointment');
        }
      });
    } else {
      this._phrutilService.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this._phrutilService.setTitle('Registro de pacientes');
        } else if (language === 'hi') {
          this._phrutilService.setTitle('रोगी पंजीकरण');
        } else if (language === 'ur') {
          this._phrutilService.setTitle('مریض کی رجسٹریشن');
        }
        else {
          this._phrutilService.setTitle('Patient Registration');
        }
      });
    }
 
  }
  GetPatientInsuranceOrSelfPay() {
    this.spinner.show();
    this._insuranceservice.GetIsSelfPayOrInsurance(this.PatientAccount, this.PracticeCode).subscribe((res: any) => {

      this.spinner.hide();
      if (res.statusCode == 200 && res.message.toLowerCase() == 'success' && res.data) {
        //console.log(res);
        this.isSelfPay = res.data.iS_SELF_PAY.toLowerCase() == 'true' ? true : false;
        this.isInsurance = res.data.iS_INSURED.toLowerCase() == 'true' ? true : false;
        if (this.isInsurance) {
          this.isSelfPay = false;
        }
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        // this._phrutilService.showError("Service is not available, please try later.");
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      // this._phrutilService.showError("Service is not available, please try later.");
    });
  }
  /* As per the requirement of the Adeel Sarwar
  That the Next button will not be available directly from the insurance
  or self pay button it will go there */
  UpdatePatientSelfPayBit(type: any) {
    this.ChangePaymentType(type);
    if (this.isInsurance || this.isSelfPay) {
      this.spinner.show();
      this.UpdatePatientSelfPayBitRequest.patientAccount = this.PatientAccount;
      this.UpdatePatientSelfPayBitRequest.practiceCode = this.PracticeCode;
      this.UpdatePatientSelfPayBitRequest.isSelfPay = this.isSelfPay ? 'true' : 'false';
      this._insuranceservice.UpdatePatientSelfPayBit(this.UpdatePatientSelfPayBitRequest).subscribe((res: any) => {

        this.spinner.hide();
        if (res.statusCode == 200 && res.message.toLowerCase() == 'success') {
          // this._phrutilService.showSuccess("Record updated successfully.");
          if (this.UpdatePatientSelfPayBitRequest.isSelfPay == 'false') {
            this.router.navigateByUrl("/insurance");
          }
          else {
            localStorage.setItem("backFromCovid", "false");
            this.router.navigateByUrl('patient/intake');
            //this.router.navigateByUrl("/thank-app");
          }
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      }, (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
    }
    else {
      let text = "Please Select Payment type.";
      this.translateService.get('Alerts.select_payment_type').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text);
      //this._phrutilService.showInfo("Please Select Payment type.");
    }
  }
  ChangePaymentType(type: any) {
    if (type == 'insurance') {
      this.isSelfPay = false;
      this.isInsurance = true;
    }
    else if (type == 'selfpay') {
      this.isSelfPay = true;
      this.isInsurance = false;
    }
  }
  backPage() {
    this.router.navigateByUrl('/appointment');
  }
}
